import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComprasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_TELAS_OC = process.env.REACT_APP_URL_TELAS_OC;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_COMPRAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_ACUMULADOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOrdenCompra, setSelectedOrdenCompra] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [colores, setColores] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [factura_proveedor, setFacturaProveedor] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [pais_origen, setPaisOrigen] = useState("Mexico");
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [total_dinero, setTotalDinero] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [impuestos, setImpuestos] = useState(false);
  const [impuestosPor, setImpuestosPor] = useState(16);

  const [telasOC, setTelasOC] = useState([]);
  const [telasOC2, setTelasOC2] = useState([]);
  const [fecha_orden_compra, setFechaOrdenCompra] = useState("");
  const [plazo, setPlazo] = useState("");
  const [proveedorOrden, setProveedorOrden] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [total_kilos_orden, setTotalKilosOrden] = useState(0);
  const [total_metros_orden, setTotalMetrosOrden] = useState(0);
  const [total_piezas_orden, setTotalPiezasOrden] = useState(0);

  const [tipo, setTipo] = useState("");
  const [observacionesOrden, setObservacionesOrden] = useState("");

  const [totalCaptura, setTotalCaptura] = useState(1);
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      telasOrden: "",
      telas: "",
      unidad: "",
      colores: "",
      cantidad: 0,
      captura: 1,
      costo: 0,
      total: 0,
    },
  ]);

  const [inputFieldsHab, setInputFieldsHab] = useState([
    {
      id: uuidv4(),
      telasOrden: "",
      habilitacion: "",
      unidad: "",
      cantidad: 0,
      captura: 1,
      costo: 0,
      total: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  // Almacen al que entra lo recibido: la bodega de materiales (vacio) o el
  // almacen de un maquilero, cuando la tela o el poquetin le llegan directo.
  const [almacenes, setAlmacenes] = useState([]);
  const [areaDestino, setAreaDestino] = useState("");

  useEffect(() => {
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOrdenesCompra = res.data;
        setOrdenesCompra(allOrdenesCompra);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) =>
        setAlmacenes(
          res.data
            .filter((a) => a.is_active !== "No" && a.tipo !== "Saldos")
            .sort((a, b) => (a.tipo === b.tipo ? a.name.localeCompare(b.name) : a.tipo === "Maquilero" ? 1 : -1))
        )
      )
      .catch((err) => console.log(err));

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const URL_COMPRAS_RECEPCION = process.env.REACT_APP_URL_COMPRAS_RECEPCION;

  /**
   * Guarda la compra en una sola llamada: cabecera, rollos/habilitacion,
   * recibido de cada renglon de OC, acumulados e inventario por almacen, todo
   * en una transaccion del back. Antes eran decenas de POST encadenados desde
   * aqui y una pestana cerrada dejaba la compra a medias.
   */
  async function guardarRecepcion(renglones) {
    setValidaBoton(false);
    setModalProgreso(true);
    try {
      const { data } = await axios.post(
        URL_COMPRAS_RECEPCION,
        {
          fecha,
          ordenesCompra: selectedOrdenCompra,
          factura_proveedor,
          observaciones,
          pais_origen,
          total_kilos,
          total_metros,
          total_piezas,
          subtotal,
          iva,
          total_costo: parseFloat(total_dinero.toFixed(2)),
          areas: areaDestino || undefined,
          renglones,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setModalProgreso(false);
      const destino = almacenes.find((a) => a._id === areaDestino);
      await Swal.fire({
        icon: "success",
        title: `Compra ${data.idCompras} registrada`,
        text: `${selectedOrdenCompra.length} orden(es) de compra recibidas · entró a ${destino ? destino.name : "la bodega de materiales"}`,
      });
      window.location.reload();
    } catch (error) {
      setModalProgreso(false);
      setValidaBoton(true);
      const info = (error.response && error.response.data) || {};
      Swal.fire({
        icon: "error",
        title: "No se pudo registrar la compra",
        text: info.message || (error.response ? `El servidor respondio ${error.response.status}` : "No hubo respuesta del servidor"),
      });
    }
  }

  const faltanDatos = () => {
    if (!selectedOrdenCompra.length) {
      Swal.fire({ icon: "error", title: "Elige al menos una orden de compra" });
      return true;
    }
    if (fecha === "" || observaciones === "" || factura_proveedor === "" || pais_origen === "") {
      Swal.fire({ icon: "error", title: "Faltan datos", text: "Fecha, factura, pais de origen y observaciones" });
      return true;
    }
    return false;
  };

  const saveCompraNueva = async (event) => {
    event.preventDefault();
    if (faltanDatos()) return;

    // Cada renglon capturado es un rollo.
    const renglones = inputFields
      .filter((a) => a.telasOrden && parseFloat(a.cantidad) > 0)
      .map((a) => ({
        telasOC: a.telasOrden,
        cantidad: parseFloat(a.cantidad),
        captura: a.captura,
        total: parseFloat(a.total) || 0,
      }));
    if (!renglones.length) return Swal.fire({ icon: "warning", title: "No hay tela capturada" });

    // Tolerancia del 5% contra lo pedido en las ordenes elegidas.
    const fuera =
      total_kilos > total_kilos_orden * 1.05 || total_metros > total_metros_orden * 1.05 ||
      total_kilos < total_kilos_orden * 0.05 || total_metros < total_metros_orden * 0.05;
    if (fuera) {
      const r = await Swal.fire({
        title: "Hay una diferencia por mas del 5% de la Orden de Compra!",
        text: "Debes de solicitar autorizacion",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Recibir!",
      });
      if (!r.value) return;
    }
    guardarRecepcion(renglones);
  };

  const saveCompraNuevaHab = async (event) => {
    event.preventDefault();
    if (faltanDatos()) return;

    const renglones = inputFieldsHab
      .filter((a) => a.telasOrden && parseFloat(a.cantidad) > 0)
      .map((a) => ({
        telasOC: a.telasOrden,
        cantidad: parseFloat(a.cantidad),
        captura: a.captura,
        costo: a.costo,
        total: parseFloat(a.total) || 0,
      }));
    if (!renglones.length) return Swal.fire({ icon: "warning", title: "No hay habilitacion capturada" });
    guardarRecepcion(renglones);
  };

  const handleAddFields = () => {
    // Un renglon por renglon de OC con la cantidad total recibida: ya no se
    // captura rollo por rollo.
    setInputFields([...inputFields, renglonTelaVacio()]);
  };
  const handleAddFieldsHab = () => {
    setInputFieldsHab([...inputFieldsHab, renglonHabVacio()]);
  };

  // Los totales (que se guardan como saldo por pagar) se recalculan cada vez
  // que cambian los renglones. Llamar ActualizaTotales() justo despues de un
  // setInputFields lee el estado anterior.
  useEffect(() => {
    if (tipo === "Tela") ActualizaTotales();
    else if (tipo) ActualizaTotalesHab();
  }, [inputFields, inputFieldsHab, impuestos, impuestosPor, tipo]);

  /** Un renglon por cada renglon de las OC elegidas, con todo lo pendiente. */
  function recibirTodo() {
    const r2 = (x) => Math.round((Number(x) || 0) * 100) / 100;
    const pendientes = telasOC
      .map((l) => ({ ...l, pendiente_recibir: r2(l.pendiente_recibir) }))
      .filter((l) => l.pendiente_recibir > 0);
    if (!pendientes.length) return Swal.fire({ icon: "info", title: "Las ordenes no tienen pendiente de recibir" });
    if (tipo === "Tela") {
      setInputFields(pendientes.map((l) => ({
        ...renglonTelaVacio(), telasOrden: l._id, telas: l.telas?.[0]?._id, unidad: l.telas?.[0]?.unidad,
        colores: l.colores?.[0]?._id, costo: l.precio, cantidad: l.pendiente_recibir,
        total: r2(l.pendiente_recibir * (l.precio || 0)),
      })));
    } else {
      setInputFieldsHab(pendientes.map((l) => ({
        ...renglonHabVacio(), telasOrden: l._id, habilitacion: l.habilitacion?.[0]?._id, unidad: l.habilitacion?.[0]?.unidad,
        costo: l.precio, cantidad: l.pendiente_recibir, total: r2(l.pendiente_recibir * (l.precio || 0)),
      })));
    }
  }

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
    let PZ = values.filter((e) => e.unidad == "Piezas");
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TP);


    let totalDin = inputFields.map((c) => parseFloat(c.total));
    let Din = totalDin.reduce((t, total, index) => t + total, 0);
    setSubtotal(Din);

    if (impuestos == true) {
      let i = parseFloat(Din) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(Din) + i);
    } else {
      setTotalDinero(parseFloat(Din));
      setIva(0);
    }
  };

  const handleRemoveFieldsHab = (id) => {
    const values = [...inputFieldsHab];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHab(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
    let PZ = values.filter((e) => e.unidad == "Piezas");
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TP);

    let totalDin = inputFieldsHab.map((c) => parseFloat(c.total));
    let Din = totalDin.reduce((t, total, index) => t + total, 0);
    setSubtotal(Din);

    if (impuestos == true) {
      let i = parseFloat(Din) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(Din) + i);
    } else {
      setTotalDinero(parseFloat(Din));
      setIva(0);
    }
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadHab = (id, event) => {
    const newInputFieldsHab = inputFieldsHab.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setInputFieldsHab(newInputFieldsHab);
    ActualizaTotalesHab();
  };

  function BuscaTela(id, event) {
    telasOC.map((a) => {
      if (a._id == event.target.value) {
        let telasOrden = a._id;
        let idTela = a.telas?.[0]?._id;
        let unidadTela = a.telas?.[0]?.unidad;
        let color = a.colores?.[0]?._id;
        let costo = a.precio;
        handleChangeInputTela(id, telasOrden, idTela, unidadTela, color, costo);
      }
    });
  }

  const handleChangeInputTela = (
    id,
    telasOrden,
    idTela,
    unidadTela,
    color,
    costo
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.telasOrden = telasOrden;
        i.telas = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.costo = costo;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let PZ = inputFields.filter((e) => e.unidad == "Piezas");
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TP);

    let totalDin = inputFields.map((c) => parseFloat(c.total));
    let Din = totalDin.reduce((t, total, index) => t + total, 0);
    setSubtotal(Din);

    if (impuestos == true) {
      let i = parseFloat(Din) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(Din) + i);
    } else {
      setTotalDinero(parseFloat(Din));
      setIva(0);
    }

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["telas"] + item["colores"];
      groups[val] = groups[val] || {
        telas: item.telas,
        colores: item.colores,
        cantidad: 0,
        total: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].total += item.total;
      groups[val].id = item.id;
      groups[val].telas = item.telas;
      groups[val].unidad = item.unidad;
      groups[val].colores = item.colores;
      groups[val].telasOrden = item.telasOrden;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
  }

  const calculaIVA = (e) => {
    setImpuestos(e);
    if (e == true) {
      let i = parseFloat(subtotal) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(subtotal) + i);
    } else {
      setTotalDinero(parseFloat(subtotal));
      setIva(0);
    }
  };

  const calculaPor = (e) => {
    setImpuestosPor(e);
    if (impuestos == true) {
      let i = parseFloat(subtotal) * (e / 100);
      setIva(i);
      setTotalDinero(parseFloat(subtotal) + i);
    } else {
      setTotalDinero(parseFloat(subtotal));
      setIva(0);
    }
  };

  function BuscaHabilitacion(id, event) {
    telasOC.map((a) => {
      if (a._id == event.target.value) {
        let telasOrden = a._id;
        let idHabilitacion = a.habilitacion?.[0]?._id;
        let unidadHabiltacion = a.habilitacion?.[0]?.unidad;
        let costo = a.precio;
        handleChangeInputHabilitacion(
          id,
          telasOrden,
          idHabilitacion,
          unidadHabiltacion,
          costo
        );
      }
    });
  }

  const handleChangeInputHabilitacion = (
    id,
    telasOrden,
    idHabilitacion,
    unidadHabiltacion,
    costo
  ) => {
    const newInputFieldsHab = inputFieldsHab.map((i) => {
      if (id === i.id) {
        i.telasOrden = telasOrden;
        i.habilitacion = idHabilitacion;
        i.unidad = unidadHabiltacion;
        i.costo = costo;
      }
      return i;
    });
    setInputFieldsHab(newInputFieldsHab);
    ActualizaTotalesHab();
  };

  function ActualizaTotalesHab() {
    let mts = inputFieldsHab.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFieldsHab.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let PZ = inputFieldsHab.filter((e) => e.unidad == "Piezas");
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TP);

    let totalDin = inputFieldsHab.map((c) => parseFloat(c.total));
    let Din = totalDin.reduce((t, total, index) => t + total, 0);
    setSubtotal(Din);

    if (impuestos == true) {
      let i = parseFloat(Din) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(Din) + i);
    } else {
      setTotalDinero(parseFloat(Din));
      setIva(0);
    }

    let agrupado = inputFieldsHab.reduce(function (groups, item) {
      const val = item["habilitacion"];
      groups[val] = groups[val] || {
        habilitacion: item.habilitacion,
        cantidad: 0,
        total: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].total += item.total;
      groups[val].id = item.id;
      groups[val].habilitacion = item.habilitacion;
      groups[val].unidad = item.unidad;
      groups[val].telasOrden = item.telasOrden;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
  }

  const renglonTelaVacio = () => ({
    id: uuidv4(), telasOrden: "", telas: "", unidad: "", colores: "",
    cantidad: 0, captura: 1, costo: 0, total: 0,
  });
  const renglonHabVacio = () => ({
    id: uuidv4(), telasOrden: "", habilitacion: "", unidad: "",
    cantidad: 0, captura: 1, costo: 0, total: 0,
  });

  /**
   * Una compra puede recibir varias ordenes de compra, siempre del mismo
   * proveedor y del mismo tipo (una factura es de un proveedor). Los datos de
   * cabecera salen de la primera; los totales pedidos, de la suma de todas.
   */
  function cargarOrdenes(ids) {
    setSelectedOrdenCompra(ids);
    const elegidas = ids.map((id) => ordenesCompra.find((a) => a._id === id)).filter(Boolean);
    const primera = elegidas[0];

    if (!primera) {
      setTelasOC([]);
      setInputFields([renglonTelaVacio()]);
      setInputFieldsHab([renglonHabVacio()]);
      setTipo("");
      setProveedorOrden("");
      return;
    }

    setFechaOrdenCompra(primera.fecha);
    setPlazo(primera.plazo);
    setFechaCompromiso(primera.fecha_compromiso);
    setProveedorOrden(primera.proveedores?.[0]?._id);
    setObservacionesOrden(elegidas.map((a) => a.observaciones).filter((o) => o && o !== "NA").join(" / "));
    setTipo(primera.tipo);
    setTotalKilosOrden(elegidas.reduce((t, a) => t + (a.total_kilos || 0), 0));
    setTotalMetrosOrden(elegidas.reduce((t, a) => t + (a.total_metros || 0), 0));
    setTotalPiezasOrden(elegidas.reduce((t, a) => t + (a.total_piezas || 0), 0));
    if (primera.impuestos == "Si") {
      setImpuestos(true);
      setImpuestosPor(16);
    }

    const cab = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    Promise.all(elegidas.map((o) => axios.get(`${URL_TELAS_OC}/ordenesCompra/${o._id}`, cab)))
      .then((respuestas) => {
        // Cada renglon sabe de que orden viene, para mostrarlo al capturar.
        const lineas = respuestas.flatMap((r, i) =>
          r.data.map((l) => ({ ...l, idOrden: elegidas[i]._id, numeroOC: elegidas[i].idOrdenCompra }))
        );
        setTelasOC(lineas);
        const vivas = new Set(lineas.map((l) => l._id));
        setInputFields((prev) => {
          const quedan = prev.filter((r) => !r.telasOrden || vivas.has(r.telasOrden));
          return quedan.length ? quedan : [renglonTelaVacio()];
        });
        setInputFieldsHab((prev) => {
          const quedan = prev.filter((r) => !r.telasOrden || vivas.has(r.telasOrden));
          return quedan.length ? quedan : [renglonHabVacio()];
        });
      })
      .catch((err) => console.log(err));
  }

  function agregaOrden(id) {
    if (!id || selectedOrdenCompra.includes(id)) return;
    const nueva = ordenesCompra.find((a) => a._id === id);
    const primera = ordenesCompra.find((a) => a._id === selectedOrdenCompra[0]);
    if (primera) {
      if (nueva.proveedores?.[0]?._id !== primera.proveedores?.[0]?._id) {
        return Swal.fire({ icon: "error", title: "Otro proveedor", text: "Solo se pueden juntar ordenes del mismo proveedor" });
      }
      if (nueva.tipo !== primera.tipo) {
        return Swal.fire({ icon: "error", title: "Otro tipo", text: "No se pueden juntar ordenes de tela y de habilitacion" });
      }
    }
    if (nueva.fecha_compromiso < hoy) {
      Swal.fire({
        title: `La orden ${nueva.idOrdenCompra} esta vencida!`,
        text: "Debes de solicitar autorizacion",
        icon: "warning",
      });
    }
    cargarOrdenes([...selectedOrdenCompra, id]);
  }

  const quitaOrden = (id) => cargarOrdenes(selectedOrdenCompra.filter((x) => x !== id));

  // Ordenes que se pueden recibir; con una ya elegida, solo las compatibles.
  const primeraElegida = ordenesCompra.find((a) => a._id === selectedOrdenCompra[0]);
  const ordenesDisponibles = ordenesCompra
    .filter((a) => a.status == "Abierto" && a.is_active == "Si" && a.autorizado == "Si")
    .filter((a) => !selectedOrdenCompra.includes(a._id))
    .filter((a) =>
      !primeraElegida ||
      (a.proveedores?.[0]?._id === primeraElegida.proveedores?.[0]?._id && a.tipo === primeraElegida.tipo)
    )
    .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1));

  return (
    <>
      <Header />
      <br />
      <br />
      {user.compras_create ? (
        <div className="card container col-10">
          <Row>
            <Col md={2}>
              <Button
                size="sm"
                href="/ListadoCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-truck" style={{ marginRight: 8, color: "#f59e0b" }} />
                Nueva Compra
              </h3>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-info-circle" />
              <span className="form-section-title">Datos Generales</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Ordenes de Compra</Label>
              <Input
                className="col-sm-12"
                type="select"
                value=""
                onChange={(e) => agregaOrden(e.target.value)}
              >
                <option value="">
                  {selectedOrdenCompra.length ? "Agregar otra orden..." : "Selecciona una Orden"}
                </option>
                {ordenesDisponibles.map((a) => (
                  <option value={a._id} key={a._id}>
                    {a.idOrdenCompra} {a.proveedores?.[0]?.razon_social}
                  </option>
                ))}
              </Input>
              <div style={{ marginTop: 6, display: "flex", flexWrap: "wrap", gap: 6 }}>
                {selectedOrdenCompra.map((id) => {
                  const o = ordenesCompra.find((a) => a._id === id);
                  return (
                    <span key={id} style={{ background: "#e0f2fe", color: "#075985", borderRadius: 12, padding: "2px 10px", fontSize: 13 }}>
                      OC {o?.idOrdenCompra}
                      <span
                        role="button"
                        title="Quitar"
                        onClick={() => quitaOrden(id)}
                        style={{ marginLeft: 8, cursor: "pointer", fontWeight: 700 }}
                      >
                        ×
                      </span>
                    </span>
                  );
                })}
              </div>
            </Col>
            <Col md={3}>
              <Label>Fecha OC</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha_orden_compra}
                required
                disabled
                onChange={(e) => {
                  setFechaOrdenCompra(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="text"
                placeholder="Plazo"
                value={plazo}
                required
                disabled
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Compromiso</Label>
              <Input
                type="date"
                placeholder="Fecha Compromiso"
                value={fecha_compromiso}
                required
                disabled
                onChange={(e) => {
                  setFechaCompromiso(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                // disabled
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Factura Proveedor</Label>
              <Input
                type="text"
                placeholder="Factura Proveedor"
                value={factura_proveedor}
                required
                onChange={(e) => {
                  setFacturaProveedor(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Pais Origen</Label>
              <Input
                type="text"
                placeholder="Pais Origen"
                value={pais_origen}
                required
                onChange={(e) => {
                  setPaisOrigen(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Recibir en</Label>
              <Input type="select" value={areaDestino} onChange={(e) => setAreaDestino(e.target.value)}>
                <option value="">Bodega de materiales</option>
                {almacenes.map((a) => (
                  <option value={a._id} key={a._id}>
                    {a.tipo === "Maquilero" ? `Directo al maquilero · ${a.name.replace(/^Maquilero - /, "")}` : a.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h4 id="logoutBoton">
                TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)} kg.
                / {new Intl.NumberFormat("en-US").format(total_metros)} mts. /{" "}
                {new Intl.NumberFormat("en-US").format(total_piezas)} pzas. /{" "}
                ${new Intl.NumberFormat("en-US").format(total_dinero)}{" "}
              </h4>
            </Col>
          </Row>
          <Row>
          <Col md={2}>
              <h3></h3>
              <Input
                type="checkbox"
                onChange={(event) => calculaIVA(event.currentTarget.checked)}
                checked={impuestos}
              />
              <Label className="subMenuTitulo">Costo mas IVA?</Label>
            </Col>
            {impuestos ? (
              <>
                <Col sm={2}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    IVA
                  </Label>
                  <Input
                    name="iva"
                    value={iva}
                    disabled
                  />
                </Col>
                <Col sm={2}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    % IVA
                  </Label>
                  <Input
                    name="impuestosPor"
                    value={impuestosPor}
                    onValueChange={(value) => calculaPor(value)}
                  />
                </Col>
              </>
            ) : undefined}

          <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones Orden Compra
              </Label>
              <Input
                type="text"
                placeholder="ObservacionesOrden"
                value={observacionesOrden}
                disabled
              />
            </Col>
          </Row>
            </div>
          </div>

          <br />
          {/* Tabla Articulos */}

          {selectedOrdenCompra.length ? (
            <Row style={{ marginBottom: 8 }}>
              <Col>
                <Button size="sm" color="info" onClick={recibirTodo}>
                  <i className="fas fa-magic" style={{ marginRight: 6 }} /> Recibir todo lo pendiente
                </Button>
              </Col>
            </Row>
          ) : undefined}
          {tipo == "Tela" ? (
            <>
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Costo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row>

              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={4}>
                      <Input
                        bsSize="sm"
                        name="telas"
                        type="select"
                        value={inputField.telasOrden}
                        required
                        onChange={(event) => {
                          BuscaTela(inputField.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {telasOC
                          .sort((a, b) =>
                            a.telas?.[0]?.codigo > b.telas?.[0]?.codigo ? 1 : -1
                          )
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {selectedOrdenCompra.length > 1 ? `OC ${a.numeroOC} · ` : ""}
                                {a.telas?.[0]?.codigo} / {a.telas?.[0]?.nombre} /{" "}
                                {a.colores?.[0]?.name} · pendiente {a.pendiente_recibir}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="unidad"
                        type="string"
                        value={inputField.unidad}
                        disabled
                      ></Input>
                    </Col>

                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="costo"
                        type="number"
                        placeholder="Costo"
                        value={inputField.costo}
                        disabled
                      />
                    </Col>
                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={inputField.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInputCantidad(inputField.id, event)
                        }
                      />
                    </Col>

                    <Col>
                      <Button title="Quitar renglón"
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFields.length === 1}
                        onClick={() => handleRemoveFields(inputField.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button title="Agregar renglón"
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFields}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
                <Col md={12}>
                  <h4 id="logoutBoton">
                    TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                    kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                    mts. / {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                    pzas. /{" "}
                    ${new Intl.NumberFormat("en-US").format(total_dinero)}{" "}
                  </h4>
                </Col>
              </Row>
              <br />
              {/* {validaBoton ? ( */}
              <>
                <Row>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={saveCompraNueva}
                  >
                    Guardar
                  </Button>
                </Row>
              </>

              {/* ) : (
                <>
                <Row>
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              <Button
                href="/ListadoCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
                </Row>
                </>
              )} */}
              <br />
            </>
          ) : undefined}

          {tipo == "Habilitacion" ? (
            <>
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Costo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row>

              {inputFieldsHab.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={4}>
                      <Input
                        bsSize="sm"
                        name="telas"
                        type="select"
                        value={inputField.telasOrden}
                        required
                        onChange={(event) => {
                          BuscaHabilitacion(inputField.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {telasOC
                          .sort((a, b) =>
                            a.habilitacion?.[0]?.nombre > b.habilitacion?.[0]?.nombre
                              ? 1
                              : -1
                          )
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {selectedOrdenCompra.length > 1 ? `OC ${a.numeroOC} · ` : ""}
                                {a.habilitacion?.[0]?.nombre} {a.habilitacion?.[0]?.descripcion} · pendiente {a.pendiente_recibir}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="unidad"
                        type="string"
                        value={inputField.unidad}
                        disabled
                      ></Input>
                    </Col>


                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="costo"
                        type="number"
                        placeholder="Costo"
                        value={inputField.costo}
                        disabled
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={inputField.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInputCantidadHab(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col>
                      <Button title="Quitar renglón"
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsHab.length === 1}
                        onClick={() => handleRemoveFieldsHab(inputField.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button title="Agregar renglón"
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsHab}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
                <Col md={12}>
                  <h4 id="logoutBoton">
                    TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                    kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                    mts. / {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                    pzas. /{" "}
                    ${new Intl.NumberFormat("en-US").format(total_dinero)}{" "}

                  </h4>
                </Col>
              </Row>

              <br />
              {validaBoton ? (
                <>
                  <Row>
                    <Button
                      type="submit"
                      className="btn btn-success"
                      onClick={saveCompraNuevaHab}
                    >
                      Guardar
                    </Button>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                    <Button
                      href="/ListadoCompras"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Row>
                </>
              )}
              <br />
            </>
          ) : undefined}

          {/* Termina Tabla Habilitacion */}

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasCreate;
